export const formatSeplReferenceNumber = (refNumber: string | number | null | undefined): string => {
  if (!refNumber) return String(refNumber ?? '');
  const ref = String(refNumber).trim();
  const legacyPattern = /^SEPL\s*-\s*D(\d{2})(\d{3})(\d{3})([A-Z])$/i;
  const legacyMatch = ref.match(legacyPattern);
  if (legacyMatch) {
    return `SEPL-${legacyMatch[1]}D${legacyMatch[2]}${legacyMatch[3]}${legacyMatch[4].toUpperCase()}`;
  }
  return ref;
};

// Normalizes an is_admin / permission flag that can arrive as a boolean, a MySQL
// tinyint (0/1), or a stringified value ('1'/'true') depending on how the SSO
// cookie or API serialized it. Strict `=== true` checks miss the numeric form,
// which is why a freshly-granted admin could fail admin gating.
export const isAdminFlag = (value: unknown): boolean =>
  value === true || value === 1 || value === '1' || value === 'true';

const sanitizeDownloadNamePart = (value: any, fallback = 'file') => {
  const normalized = String(value ?? '')
    .trim()
    .replace(/\.[a-z0-9]+$/i, '')
    .replace(/[^a-z0-9._-]+/gi, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');
  return normalized || fallback;
};

export const getLastFourReferenceDigits = (refNumber: any, serialNumber: any) => {
  const refDigits = String(refNumber ?? '').replace(/\D+/g, '');
  if (refDigits.length >= 4) return refDigits.slice(-4);
  const serialDigits = String(serialNumber ?? '').replace(/\D+/g, '');
  if (!serialDigits) return '';
  return serialDigits.padStart(4, '0').slice(-4);
};

export const buildLetterDownloadBaseName = ({
  letterNumber,
  serialNumber,
  preferredName,
  fallbackName = 'letter',
}: { letterNumber?: any; serialNumber?: any; preferredName?: any; fallbackName?: string } = {}) => {
  const safeBaseName = sanitizeDownloadNamePart(preferredName, fallbackName);
  const formattedRef = formatSeplReferenceNumber(letterNumber);
  if (!formattedRef) return safeBaseName;
  return `${formattedRef} (${safeBaseName})`;
};

export const buildLetterDownloadFileName = ({ extension = '', ...options }: any = {}) => {
  const baseName = buildLetterDownloadBaseName(options);
  const normalizedExtension = String(extension || '').trim().replace(/^\./, '');
  return normalizedExtension ? `${baseName}.${normalizedExtension}` : baseName;
};
